import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppService } from './core/services/app.service';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'futuristiclevelz';
    public environment = environment;
    public showHeaderFooter = true;
    private authRoutes = ['login', 'register', 'logout'];

    constructor(
        public appService: AppService,
        private router: Router
    ) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                this.checkRoute(event.urlAfterRedirects || event.url);
            });
    }

    private checkRoute(url: string): void {
        this.showHeaderFooter = !this.authRoutes.some(route => url.includes(route));
    }

    public getFooterState() {
        return this.appService.isFooterVisible;
    }

    public ngAfterViewInit(): void {
        /*
        setTimeout(() => {
            for (let i = 1; i <= 10; i++) {
                let moon = this.getSmallMoon();
                $('#approot').append(moon);
            }

            for (let i = 1; i <= 6; i++) {
                let res = this.getShiningStar();
                $('#approot').append(res);
            }

            for (let i = 1; i <= 8; i++) {
                let res = this.getStarSmall();
                $('#approot').append(res);
            }

            for (let i = 1; i <= 5; i++) {
                let res = this.metior();
                $('#approot').append(res);
            }

            for (let i = 1; i <= 3; i++) {
                let res = this.getPlanet();
                $('#approot').append(res);
            }

            for (let i = 1; i <= 1; i++) {
                let res = this.jupiter();
                $('#approot').append(res);
            }

            for (let i = 1; i <= 5; i++) {
                let res = this.getStar();
                $('#approot').append(res);
            }

            for (let i = 1; i <= 3; i++) {
                let res = this.multistars();
                $('#approot').append(res);
            }
        }, 5000);
        */

        /*
        setTimeout(() => {
            $('.ast-metior').addClass('left-down-c');
        }, 6000);


        setTimeout(() => {
            $('.ast-metior').remove();
        }, 360 * 1000);
        */
    }

    private randomIntFromInterval(min: any, max: any): any {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    private getSmallMoon() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 50);
        return `
    <svg class="e-asset bg-asset-c h-s-2" width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
      <path
          d="M0.416862 3.85506C-0.351675 2.72248 -0.0280821 1.18541 1.14495 0.416871C2.27753 -0.351666 3.8146 -0.0281014 4.58314 1.14493C5.35168 2.27751 5.02808 3.81458 3.85505 4.58312C2.68202 5.31121 1.1854 4.98764 0.416862 3.85506Z"
          fill="url(#paint0_linear_1004_10)" />
      <defs>
          <linearGradient id="paint0_linear_1004_10" x1="2.5" y1="0" x2="2.5" y2="4.9719" gradientUnits="userSpaceOnUse">
              <stop stop-color="#74F4F8" />
              <stop offset="0.536458" stop-color="#42A8F5" />
              <stop offset="1" stop-color="#064EF1" />
          </linearGradient>
      </defs>
  </svg>
    `;
    }

    private getShiningStar() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 50);
        return `
    <svg class="e-asset" width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
      <g class="bg-asset-c h-s-1-2" opacity="0.5" filter="url(#filter0_d_1004_114)">
      <circle cx="25.5" cy="19.5" r="13.5" fill="url(#paint0_linear_1004_114)" fill-opacity="0.1"/>
      </g>
      <g opacity="0.5" filter="url(#filter1_d_1004_114)">
      <circle cx="25.6603" cy="19.3393" r="8.19643" fill="url(#paint1_linear_1004_114)" fill-opacity="0.2"/>
      </g>
      <g opacity="0.5" filter="url(#filter2_d_1004_114)">
      <circle cx="25.661" cy="19.3393" r="5.30357" fill="url(#paint2_linear_1004_114)" fill-opacity="0.4"/>
      </g>
      <g opacity="0.5" filter="url(#filter3_d_1004_114)">
      <circle cx="25.5798" cy="19.421" r="3.10714" fill="url(#paint3_linear_1004_114)" fill-opacity="0.5"/>
      <circle cx="25.5798" cy="19.421" r="2.60714" stroke="url(#paint4_linear_1004_114)"/>
      </g>
      <path class="bg-asset-c h-s-2" d="M24.1841 20.3011C23.6472 19.4958 23.8709 18.3998 24.6986 17.8629C25.5039 17.3261 26.5999 17.5498 27.1368 18.3774C27.6736 19.1827 27.45 20.2788 26.6223 20.8156C25.817 21.3525 24.7209 21.1288 24.1841 20.3011Z" fill="url(#paint5_linear_1004_114)"/>
      <defs>
      <filter id="filter0_d_1004_114" x="0" y="0" width="51" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="6"/>
      <feGaussianBlur stdDeviation="6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.203922 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_114"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_114" result="shape"/>
      </filter>
      <filter id="filter1_d_1004_114" x="5.46387" y="5.14282" width="40.3926" height="40.3928" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="6"/>
      <feGaussianBlur stdDeviation="6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.204167 0 0 0 0 0.618 0 0 0 0 1 0 0 0 0.33 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_114"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_114" result="shape"/>
      </filter>
      <filter id="filter2_d_1004_114" x="8.35742" y="8.03577" width="34.6074" height="34.6072" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="6"/>
      <feGaussianBlur stdDeviation="6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.204167 0 0 0 0 0.618 0 0 0 0 1 0 0 0 0.33 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_114"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_114" result="shape"/>
      </filter>
      <filter id="filter3_d_1004_114" x="10.4727" y="10.3138" width="30.2139" height="30.2142" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="6"/>
      <feGaussianBlur stdDeviation="6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.203922 0 0 0 0 0.619608 0 0 0 0 1 0 0 0 0.13 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_114"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_114" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear_1004_114" x1="25.5" y1="6" x2="25.5" y2="33" gradientUnits="userSpaceOnUse">
      <stop stop-color="#74F4F8"/>
      <stop offset="0.536458" stop-color="#42A8F5"/>
      <stop offset="1" stop-color="#064EF1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_1004_114" x1="25.6603" y1="11.1428" x2="25.6603" y2="27.5357" gradientUnits="userSpaceOnUse">
      <stop stop-color="#74F4F8"/>
      <stop offset="0.536458" stop-color="#42A8F5"/>
      <stop offset="1" stop-color="#064EF1"/>
      </linearGradient>
      <linearGradient id="paint2_linear_1004_114" x1="25.661" y1="14.0358" x2="25.661" y2="24.6429" gradientUnits="userSpaceOnUse">
      <stop stop-color="#74F4F8"/>
      <stop offset="0.536458" stop-color="#42A8F5"/>
      <stop offset="1" stop-color="#064EF1"/>
      </linearGradient>
      <linearGradient id="paint3_linear_1004_114" x1="25.5798" y1="16.3138" x2="25.5798" y2="22.5281" gradientUnits="userSpaceOnUse">
      <stop stop-color="#74F4F8"/>
      <stop offset="0.536458" stop-color="#42A8F5"/>
      <stop offset="1" stop-color="#064EF1"/>
      </linearGradient>
      <linearGradient id="paint4_linear_1004_114" x1="25.5798" y1="16.3138" x2="25.5798" y2="22.5281" gradientUnits="userSpaceOnUse">
      <stop stop-color="#74F4F8"/>
      <stop offset="0.536458" stop-color="#42A8F5"/>
      <stop offset="1" stop-color="#064EF1"/>
      </linearGradient>
      <linearGradient id="paint5_linear_1004_114" x1="25.6604" y1="17.5714" x2="25.6604" y2="21.1071" gradientUnits="userSpaceOnUse">
      <stop stop-color="#74F4F8"/>
      <stop offset="0.536458" stop-color="#42A8F5"/>
      <stop offset="1" stop-color="#064EF1"/>
      </linearGradient>
      </defs>
      </svg>
    `;
    }

    private metior() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 50);
        return `
    <svg class="e-asset bg-asset-c h-s-1-2 ast-metior" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
      <path d="M29.0533 0.0596297C30.3533 1.35963 7.75332 27.2596 6.15332 28.8596C4.55332 30.4596 2.15332 30.6596 0.853319 29.3596C-0.446681 28.0596 -0.246681 25.6596 1.35332 24.0596C2.85332 22.3596 27.7533 -1.34037 29.0533 0.0596297Z" fill="url(#paint0_linear_1004_31)"/>
      <defs>
      <linearGradient id="paint0_linear_1004_31" x1="-52.7174" y1="29.7381" x2="-56.3928" y2="16.4589" gradientUnits="userSpaceOnUse">
      <stop offset="0.00247525" stop-color="#537EFB" stop-opacity="0.38"/>
      <stop offset="0.0766" stop-color="#375CC7" stop-opacity="0.44"/>
      <stop offset="0.2176" stop-color="#354F9C" stop-opacity="0.24"/>
      <stop offset="0.3424" stop-color="#213A83" stop-opacity="0.28"/>
      <stop offset="0.4449" stop-color="#172F74" stop-opacity="0.46"/>
      <stop offset="0.518906" stop-color="#142968" stop-opacity="0.56"/>
      <stop offset="0.7697" stop-color="#191B32" stop-opacity="0.1"/>
      <stop offset="1" stop-color="#0A1943" stop-opacity="0"/>
      </linearGradient>
      </defs>
    </svg>
    `;
    }

    private getPlanet() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 150);
        return `
    <svg class="e-asset bg-asset-c h-s-1-2" width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
        <path
            d="M32.5921 68.5284C50.5779 70.4041 66.6787 57.3443 68.5544 39.3585C70.4301 21.3728 57.3703 5.27187 39.3845 3.3962C21.3987 1.52053 5.29783 14.5804 3.42216 32.5661C1.54648 50.5519 14.6063 66.6528 32.5921 68.5284Z"
            fill="url(#paint0_linear_1004_133)" />
        <path
            d="M39.3848 3.39628C25.355 1.93316 12.4348 9.61091 6.63366 21.5552C10.9242 20.7993 14.3483 21.758 17.4517 24.1446C21.0297 26.9244 26.4418 24.4804 30.8163 17.9744C35.1996 11.3833 37.3244 19.8565 41.0527 25.3165C44.781 30.7766 47.8164 23.0994 46.8606 15.7797C46.712 14.7327 46.3598 11.5157 48.002 11.4291C49.8231 11.2752 51.2613 13.1443 52.3453 14.2887C53.6577 15.7149 55.0375 17.32 56.7345 18.3566C58.5837 19.5808 60.7324 20.4066 62.89 21.1473C63.3824 21.3706 63.8837 21.5088 64.385 21.6471C64.5551 21.6648 65.6516 21.8651 65.7189 22.044C60.9212 12.0028 51.2038 4.62884 39.3848 3.39628Z"
            fill="url(#paint1_linear_1004_133)" />
        <path opacity="0.2"
            d="M40.8706 68.2744C44.2754 67.7699 47.4783 66.7287 50.4705 65.2357C51.289 64.8053 52.0224 64.3661 52.8497 63.8507C55.5195 62.1522 58.0547 60.0958 60.3614 57.7578C64.8314 52.8088 67.8188 46.416 68.5548 39.3586C68.6879 38.0831 68.7447 36.7138 68.7077 35.4206C68.0645 36.6429 67.113 38.3486 66.8897 38.8411C65.5095 41.3617 64.8147 44.7274 62.0865 46.162C61.268 46.5923 59.9164 46.3654 59.2043 45.7754C57.2293 44.1083 56.475 41.451 55.6852 39.1338C55.2142 37.8814 54.837 36.5527 54.5449 35.233C54.4369 34.62 54.2439 33.9982 54.1447 33.3002L54.1536 33.2152C54.5287 37.0363 55.3321 44.1683 51.9341 47.0802C44.9503 53.0562 36.3404 43.3051 34.7769 36.8674C34.1076 34.219 33.7555 31.002 33.9542 28.2722C33.2516 37.4819 24.0889 43.7465 15.8797 45.8128C13.4953 46.4237 9.59802 46.7049 7.31475 45.5213C6.32987 45.0748 4.17598 43.4749 3.94227 42.4191C3.9334 42.5041 3.93341 42.5041 4.00957 42.598C4.05026 43.032 4.18485 43.3899 4.31057 43.8328C4.37786 44.0117 4.44515 44.1906 4.50358 44.4545C4.562 44.7185 4.62042 44.9825 4.76388 45.2553C4.83117 45.4342 4.88962 45.6982 4.95691 45.8771C5.01534 46.141 5.15879 46.4139 5.21722 46.6778C5.28451 46.8567 5.35179 47.0357 5.41022 47.2996C5.55368 47.5725 5.6121 47.8364 5.74669 48.1943C5.81398 48.3732 5.88129 48.5521 5.94859 48.731C6.15934 49.1828 6.29392 49.5406 6.50467 49.9924C6.57196 50.1713 6.64811 50.2652 6.71541 50.4441C6.85886 50.7169 7.00233 50.9898 7.14578 51.2626C7.21308 51.4415 7.36539 51.6293 7.43269 51.8082C7.57614 52.0811 7.72847 52.2688 7.87193 52.5417C7.93922 52.7206 8.09154 52.9084 8.15883 53.0873C8.30229 53.3601 8.44576 53.6329 8.68311 53.8296C8.7504 54.0085 8.91159 54.1113 8.97888 54.2902C9.1985 54.6569 9.50315 55.0325 9.8078 55.4081C9.88396 55.502 9.96011 55.5959 10.0363 55.6898C10.2648 55.9715 10.4933 56.2532 10.7217 56.5349C10.8741 56.7227 10.9502 56.8166 11.1026 57.0044C11.3399 57.201 11.4834 57.4738 11.7207 57.6705C11.873 57.8583 11.9492 57.9522 12.1015 58.14C12.3389 58.3366 12.4823 58.6095 12.7197 58.8061C12.8809 58.9089 12.9482 59.0878 13.1093 59.1906C13.4229 59.4811 13.7364 59.7717 13.9649 60.0534C14.0499 60.0622 14.041 60.1473 14.1261 60.1561C14.4396 60.4467 14.8292 60.8311 15.2278 61.1306C15.389 61.2333 15.4651 61.3272 15.6263 61.43C15.8637 61.6266 16.101 61.8233 16.4234 62.0288C16.5846 62.1316 16.7458 62.2344 16.822 62.3283C17.0593 62.5249 17.2967 62.7216 17.619 62.9271C17.7802 63.0299 17.9414 63.1326 18.0176 63.2265C18.34 63.4321 18.6624 63.6376 18.9847 63.8431C19.0609 63.937 19.1459 63.9459 19.2221 64.0398C19.6295 64.2542 20.028 64.5536 20.4354 64.768C20.5116 64.8619 20.6817 64.8796 20.7578 64.9735C21.0802 65.179 21.4115 65.2995 21.7338 65.5051C21.895 65.6078 22.0651 65.6256 22.2263 65.7283C22.5575 65.8488 22.7949 66.0455 23.1261 66.166C23.2873 66.2688 23.4574 66.2865 23.6186 66.3893C23.9498 66.5098 24.2811 66.6302 24.6123 66.7507C24.7824 66.7685 24.8585 66.8624 25.0286 66.8801C25.5299 67.0184 25.9373 67.2327 26.4386 67.371C26.5236 67.3798 26.6087 67.3887 26.6848 67.4826C27.1011 67.612 27.4324 67.7325 27.8486 67.8618C28.0187 67.8796 28.1799 67.9823 28.35 68.0001C28.6812 68.1206 29.0213 68.156 29.3526 68.2765C29.5226 68.2943 29.6927 68.312 29.8539 68.4148C30.194 68.4503 30.5252 68.5707 30.8654 68.6062C31.0354 68.6239 31.2055 68.6417 31.3755 68.6594C31.8857 68.7126 32.3959 68.7658 32.906 68.819C34.6917 69.0052 36.5889 68.9452 38.4011 68.8764C38.9645 68.4194 39.9087 68.4319 40.8706 68.2744Z"
            fill="#212A3C" />
        <path opacity="0.3"
            d="M48.9335 12.3858C52.5073 20.1505 46.4406 30.5199 35.4287 35.5602C24.4167 40.6004 12.619 38.3387 9.054 30.4889C5.48011 22.7242 11.5468 12.3548 22.5588 7.31451C33.5619 2.35927 45.4446 4.62992 48.9335 12.3858Z"
            fill="url(#paint2_linear_1004_133)" />
        <path opacity="0.2"
            d="M39.5068 10.4571C41.5965 15.1446 37.4949 21.5072 30.3608 24.8031C23.2267 28.0989 15.6946 26.9696 13.5198 22.2732C11.43 17.5857 15.5317 11.2231 22.6658 7.92726C29.8849 4.64028 37.417 5.76959 39.5068 10.4571Z"
            fill="white" />
        <defs>
            <linearGradient id="paint0_linear_1004_133" x1="39.3845" y1="3.3962" x2="32.5921" y2="68.5284"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#2B4D8F" />
                <stop offset="0.291667" stop-color="#204080" />
                <stop offset="0.572917" stop-color="#0F285A" />
                <stop offset="0.817708" stop-color="#071838" />
                <stop offset="1" stop-color="#001132" />
            </linearGradient>
            <linearGradient id="paint1_linear_1004_133" x1="38.1094" y1="3.26327" x2="35.6484" y2="26.8613"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#2B4D8F" />
                <stop offset="0.291667" stop-color="#204080" />
                <stop offset="0.572917" stop-color="#0F285A" />
                <stop offset="0.817708" stop-color="#071838" />
                <stop offset="1" stop-color="#001132" />
            </linearGradient>
            <linearGradient id="paint2_linear_1004_133" x1="22.8682" y1="11.6441" x2="35.8308" y2="31.9818"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>`;
    }

    private jupiter() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 300);
        return `
    <svg class="e-asset bg-asset-c h-s-1-2" width="336" height="243" viewBox="0 0 336 243" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
    <g opacity="0.17">
        <path
            d="M154.733 90.9089C79.8431 124.779 25.6706 167.86 33.9221 186.813C42.0274 205.811 109.406 193.774 184.296 159.904C259.186 126.034 313.359 82.9523 305.107 63.9998C296.955 44.8527 229.623 57.0386 154.733 90.9089ZM180.739 155.256C127.886 179.229 67.4291 194.386 59.4185 175.687C51.3605 156.839 103.14 121.384 155.992 97.4118C208.845 73.4392 269.302 58.2826 277.313 76.9812C285.371 95.8293 233.592 131.284 180.739 155.256ZM158.642 100.206C103.791 124.957 64.2367 156.486 70.2457 170.387C76.2547 184.287 125.438 175.553 180.242 150.652C235.045 125.751 274.647 94.3713 268.638 80.4707C262.629 66.5701 213.445 75.305 158.642 100.206ZM177.695 147.17C139.129 164.614 94.8804 175.768 88.9662 162.166C83.0046 148.415 120.959 122.464 159.526 105.02C198.092 87.5754 242.341 76.4217 248.255 90.0234C254.216 103.774 216.408 129.681 177.695 147.17Z"
            fill="url(#paint0_linear_1004_147)" />
        <path
            d="M238.894 126.602C239.776 126.334 240.342 125.649 240.157 125.072C239.972 124.496 239.106 124.246 238.224 124.514C237.342 124.782 236.777 125.467 236.962 126.043C237.147 126.62 238.012 126.87 238.894 126.602Z"
            fill="url(#paint1_linear_1004_147)" />
        <path opacity="0.7"
            d="M243.808 98.1176C257.561 140.775 235.085 185.582 193.646 198.116C152.207 210.65 107.4 186.194 93.6476 143.536C79.8947 100.878 102.371 56.071 143.81 43.5373C185.249 31.0036 230.008 55.3111 243.808 98.1176Z"
            fill="url(#paint2_linear_1004_147)" />
        <path
            d="M174.333 179.572C166.116 179.911 159.454 183.11 152.693 187.506C147.635 190.716 140.148 189.332 134.458 192.068C152.202 200.994 172.865 203.527 192.851 197.431C207.44 192.981 219.745 184.392 229.036 173.389C228.063 173.352 226.945 173.36 225.972 173.323C217.853 173.466 209.343 175.895 201.368 176.994C192.178 178.296 183.231 179.358 174.333 179.572Z"
            fill="url(#paint3_linear_1004_147)" />
        <path
            d="M218.997 115.076C214.905 114.819 211.008 114.166 206.964 114.062C202.142 114.029 197.269 115.862 192.689 117.1C183.043 119.558 173.592 119.097 163.8 120.086C156.346 120.862 149.719 124.747 143.579 128.651C139.437 131.268 135.441 133.841 130.862 135.584C126.282 137.327 121.556 138.105 117.122 140.308C109.813 144.066 102.65 147.779 95.2926 151.384C96.4121 153.9 97.4829 156.262 98.6999 158.579C99.6744 158.111 100.649 157.644 101.672 157.33C108.981 154.076 115.657 149.839 122.77 146.477C130.469 142.936 138.215 141.566 145.573 136.952C154.539 131.339 162.092 127.843 172.809 127.747C181.481 127.774 189.471 126.162 197.802 124.108C202.577 122.978 207.059 121.937 212.125 122.231C216.217 122.488 220.114 123.141 224.109 123.092C231.709 122.776 238.385 117.53 244.33 113.518C245.548 112.808 246.62 112.142 247.692 111.477C247.303 108.737 246.72 105.889 246.136 103.041C237.317 108.104 229.909 115.593 218.997 115.076Z"
            fill="url(#paint4_linear_1004_147)" />
        <path
            d="M230.03 135.422C220.881 135.878 212.169 139.212 202.874 139.712C194.991 140.115 183.75 138.534 176.984 142.945C174.599 144.511 172.798 146.4 170.899 148.486C168.66 151.011 162.578 149.526 159.219 151.556C156.153 153.498 153.621 156.112 150.749 158.161C147.78 160.408 141.26 159.056 137.707 159.473C128.656 160.234 120.916 166.615 113.712 171.662C112.543 172.521 111.229 173.425 110.061 174.284C113.758 178.339 117.649 182.001 121.882 185.223C127.626 180.623 134.1 175.799 140.621 175.143C148.115 174.524 154.587 175.222 160.915 170.443C164.274 167.91 165.735 165.456 170.455 165.685C174.348 165.833 178.485 163.229 181.163 160.571C183.694 157.956 184.278 156.774 188.123 156.267C192.454 155.779 196.785 155.793 201.067 155.654C210.605 155.414 219.122 152.977 228.466 151.625C233.187 150.851 237.907 151.08 242.724 151.614C244.575 146.866 245.843 141.795 246.769 136.66C241.319 135.65 235.723 135.187 230.03 135.422Z"
            fill="url(#paint5_linear_1004_147)" />
        <path
            d="M168.836 53.3638C175.991 50.6727 183.001 47.022 190.205 44.4834C175.801 40.0195 160.13 39.6252 144.797 44.3158C130.925 48.5597 119.29 56.3032 110.332 66.4082C117.243 65.4654 124.106 63.868 129.703 62.8251C139.875 61.0521 156.521 57.9681 168.836 53.3638Z"
            fill="url(#paint6_linear_1004_147)" />
        <path
            d="M91.3027 102.336C97.6334 98.5527 104.548 95.5963 111.219 92.8822C117.89 90.1681 124.268 89.5555 131.133 88.4584C139.362 87.1113 146.714 84.5237 154.262 81.0381C157.33 79.5954 160.398 78.1527 163.417 76.5573C167.848 74.3616 171.207 74.8414 176.124 75.1793C183.476 75.6097 190.731 73.7226 197.645 71.7723C205.143 69.6429 212.495 68.5644 220.042 67.0908C221.844 66.7066 223.402 66.0616 225.106 65.3719C220.532 60.5702 215.421 56.6033 209.97 53.0761C204.224 54.1655 198.382 54.9493 192.685 56.6945C185.089 59.0213 177.932 59.7049 170.045 59.1032C161.476 58.375 154.366 63.7384 146.916 67.0265C132.502 73.6212 116.728 73.4238 102.12 79.4075C101.146 79.8735 100.124 80.1868 99.2957 80.608C95.6417 87.2598 93.0098 94.6043 91.3027 102.336Z"
            fill="url(#paint7_linear_1004_147)" />
        <path
            d="M198.6 86.0141C189.042 86.2571 179.875 86.2105 170.608 88.9015C161.342 91.5926 151.88 94.6824 142.711 98.1895C138.273 99.8978 134.566 102.396 130.615 105.138C126.127 108.215 121.592 109.616 116.422 111.042C107.253 113.534 97.889 116.932 88.8659 120.901C88.8653 122.425 88.9624 123.748 89.1081 125.226C98.5701 121.121 108.178 117.478 117.64 114.896C125.443 112.657 130.564 110.061 137.149 105.49C145.588 99.6705 157.048 97.825 166.607 94.5359C183.824 88.5448 201.963 92.0829 219.228 86.7537C225.373 84.8569 231.469 82.8058 237.663 81.5709C236.932 80.2736 236.25 79.1306 235.567 77.9875C233.129 78.4018 230.739 78.9702 228.398 79.6928C218.352 82.4556 209.28 85.7633 198.6 86.0141Z"
            fill="url(#paint8_linear_1004_147)" />
        <path
            d="M224.047 97.0259C226.451 96.2978 228.012 94.5022 227.533 93.0153C227.054 91.5284 224.717 90.9133 222.313 91.6414C219.909 92.3696 218.348 94.1652 218.827 95.6521C219.306 97.1389 221.643 97.7541 224.047 97.0259Z"
            fill="url(#paint9_linear_1004_147)" />
        <path
            d="M114.644 127.812C117.048 127.084 118.609 125.288 118.13 123.801C117.651 122.315 115.314 121.699 112.91 122.428C110.506 123.156 108.945 124.951 109.423 126.438C109.902 127.925 112.239 128.54 114.644 127.812Z"
            fill="url(#paint10_linear_1004_147)" />
        <path
            d="M218.333 134.354C220.737 133.626 222.298 131.831 221.819 130.344C221.341 128.857 219.003 128.242 216.599 128.97C214.195 129.698 212.634 131.494 213.113 132.98C213.592 134.467 215.929 135.082 218.333 134.354Z"
            fill="url(#paint11_linear_1004_147)" />
        <path
            d="M137.097 58.0757C139.501 57.3476 141.062 55.552 140.583 54.0651C140.104 52.5782 137.767 51.9631 135.363 52.6913C132.959 53.4194 131.398 55.215 131.877 56.7019C132.355 58.1888 134.692 58.8039 137.097 58.0757Z"
            fill="url(#paint12_linear_1004_147)" />
        <path
            d="M194.891 173.654C196.333 173.217 197.265 172.127 196.972 171.218C196.68 170.31 195.274 169.927 193.831 170.364C192.389 170.801 191.457 171.891 191.749 172.8C192.042 173.708 193.448 174.091 194.891 173.654Z"
            fill="url(#paint13_linear_1004_147)" />
        <path
            d="M171.14 102.745C172.582 102.308 173.514 101.218 173.221 100.309C172.929 99.4007 171.523 99.0184 170.08 99.4551C168.638 99.8919 167.706 100.982 167.998 101.891C168.291 102.799 169.697 103.182 171.14 102.745Z"
            fill="url(#paint14_linear_1004_147)" />
        <path
            d="M142.537 151.242C143.979 150.805 144.911 149.714 144.619 148.806C144.326 147.898 142.92 147.515 141.478 147.952C140.035 148.389 139.103 149.479 139.396 150.388C139.688 151.296 141.095 151.678 142.537 151.242Z"
            fill="url(#paint15_linear_1004_147)" />
        <path
            d="M189.685 53.9954C190.566 53.7287 191.13 53.044 190.944 52.4662C190.758 51.8884 189.892 51.6363 189.011 51.9031C188.13 52.1698 187.567 52.8545 187.753 53.4323C187.939 54.0101 188.804 54.2622 189.685 53.9954Z"
            fill="url(#paint16_linear_1004_147)" />
        <path
            d="M119.638 70.7223C120.519 70.4555 121.083 69.7709 120.897 69.1931C120.711 68.6153 119.846 68.3632 118.964 68.63C118.083 68.8968 117.52 69.5814 117.706 70.1592C117.892 70.7369 118.757 70.9891 119.638 70.7223Z"
            fill="url(#paint17_linear_1004_147)" />
        <path
            d="M145.392 115.595C146.273 115.328 146.837 114.643 146.651 114.065C146.465 113.488 145.6 113.235 144.718 113.502C143.837 113.769 143.274 114.454 143.46 115.031C143.646 115.609 144.511 115.861 145.392 115.595Z"
            fill="url(#paint18_linear_1004_147)" />
        <path
            d="M197.728 106.639C197.92 107.237 197.34 107.905 196.469 108.169C195.599 108.432 194.73 108.203 194.537 107.605C194.345 107.008 194.925 106.34 195.796 106.076C196.666 105.813 197.535 106.042 197.728 106.639Z"
            fill="url(#paint19_linear_1004_147)" />
        <path
            d="M205.644 75.2277C206.525 74.9609 207.089 74.2763 206.903 73.6985C206.717 73.1207 205.851 72.8686 204.97 73.1354C204.089 73.4022 203.526 74.0868 203.712 74.6645C203.898 75.2423 204.763 75.4944 205.644 75.2277Z"
            fill="url(#paint20_linear_1004_147)" />
        <path
            d="M175.907 135.648C176.099 136.246 175.518 136.914 174.648 137.178C173.778 137.441 172.908 137.212 172.716 136.614C172.523 136.017 173.104 135.349 173.974 135.085C174.893 134.971 175.762 135.2 175.907 135.648Z"
            fill="url(#paint21_linear_1004_147)" />
        <path
            d="M172.607 175.45C173.488 175.183 174.052 174.499 173.866 173.921C173.679 173.343 172.814 173.091 171.933 173.358C171.052 173.625 170.489 174.309 170.675 174.887C170.861 175.465 171.726 175.717 172.607 175.45Z"
            fill="url(#paint22_linear_1004_147)" />
        <path
            d="M219.468 163.38C219.661 163.978 219.08 164.646 218.21 164.909C217.339 165.173 216.47 164.944 216.277 164.346C216.085 163.748 216.666 163.08 217.536 162.817C218.406 162.553 219.276 162.782 219.468 163.38Z"
            fill="url(#paint23_linear_1004_147)" />
        <path
            d="M120.079 159.687C120.96 159.42 121.523 158.735 121.337 158.158C121.151 157.58 120.286 157.328 119.405 157.594C118.524 157.861 117.96 158.546 118.147 159.124C118.333 159.701 119.198 159.954 120.079 159.687Z"
            fill="url(#paint24_linear_1004_147)" />
        <path
            d="M108.645 103.095C108.837 103.693 108.257 104.361 107.386 104.624C106.516 104.888 105.647 104.659 105.454 104.061C105.262 103.463 105.842 102.795 106.713 102.532C107.583 102.268 108.452 102.497 108.645 103.095Z"
            fill="url(#paint25_linear_1004_147)" />
        <path
            d="M169.497 82.1624C169.69 82.7602 169.109 83.4281 168.239 83.6916C167.369 83.955 166.499 83.7262 166.307 83.1284C166.114 82.5306 166.695 81.8627 167.565 81.5993C168.338 81.5291 169.353 81.714 169.497 82.1624Z"
            fill="url(#paint26_linear_1004_147)" />
        <path opacity="0.2"
            d="M213.787 55.8558C200.777 98.6542 173.431 167.833 128.521 188.439C147.48 200.503 171.024 204.649 193.571 197.829C235.051 185.283 257.55 140.43 243.783 97.7297C238.171 80.3221 227.354 65.9584 213.787 55.8558Z"
            fill="#141334" />
        <path opacity="0.2"
            d="M243.122 95.2723C228.286 133.711 198.697 184.651 144.322 196.194C159.777 201.682 176.785 202.601 193.317 197.596C234.937 184.995 257.512 139.95 243.699 97.0654C243.507 96.4677 243.314 95.87 243.122 95.2723Z"
            fill="#151333" />
        <path
            d="M305.108 63.996C300.007 51.9483 270.953 52.3566 231.178 62.9544C232.955 65.5249 234.878 68.0505 236.654 70.621C257.768 66.9136 273.4 68.174 277.313 76.9779C285.371 95.8267 233.591 131.282 180.738 155.256C127.885 179.23 67.4267 194.387 59.416 175.687C55.3139 166.285 66.4023 152.702 84.8311 138.5C83.9784 135.809 83.5166 132.834 82.956 130.053C48.523 152.953 28.5262 174.856 33.6271 186.904C41.7326 205.902 109.112 193.865 184.003 159.993C259.186 126.032 313.213 82.9942 305.108 63.996Z"
            fill="url(#paint27_linear_1004_147)" />
        <path
            d="M239.24 74.7028C239.287 74.8523 239.48 74.9569 239.575 75.256C241.297 78.6651 242.485 81.9101 243.283 85.4395C245.85 86.4549 247.587 87.8896 248.444 90.0877C254.406 103.845 216.447 129.806 177.876 147.258C139.305 164.709 95.0512 175.867 89.1363 162.26C87.8017 159.06 88.8049 155.141 91.609 150.831C89.7807 148.604 88.1973 146.137 86.8587 143.43C73.9922 154.448 67.6456 164.279 70.22 170.38C76.2297 184.286 125.419 175.548 180.229 150.637C235.039 125.725 274.646 94.3329 268.636 80.4266C266.061 74.3257 255.095 72.613 239.24 74.7028Z"
            fill="url(#paint28_linear_1004_147)" />
        <path opacity="0.5"
            d="M174.402 53.3317C190.031 67.8362 186.989 97.4711 167.475 119.383C147.962 141.294 119.384 147.36 103.756 132.856C88.1268 118.351 91.1687 88.7165 110.682 66.805C130.196 44.8934 158.773 38.8271 174.402 53.3317Z"
            fill="url(#paint29_linear_1004_147)" fill-opacity="0.1" />
        <path opacity="0.4"
            d="M151.601 58.0677C160.933 66.8211 158.313 85.4047 145.574 99.717C132.835 114.029 114.918 118.654 105.586 109.9C96.1089 101.191 98.8736 82.5633 111.612 68.251C124.206 53.9827 142.124 49.3583 151.601 58.0677Z"
            fill="white" />
    </g>
    <defs>
        <linearGradient id="paint0_linear_1004_147" x1="156.886" y1="85.558" x2="181.462" y2="165.435"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint1_linear_1004_147" x1="238.224" y1="124.514" x2="238.862" y2="126.612"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint2_linear_1004_147" x1="143.81" y1="43.5373" x2="190.823" y2="198.97"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint3_linear_1004_147" x1="179.835" y1="176.747" x2="186.715" y2="199.302"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint4_linear_1004_147" x1="167.878" y1="118.279" x2="174.255" y2="139.044"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint5_linear_1004_147" x1="174.471" y1="143.104" x2="182.688" y2="169.974"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint6_linear_1004_147" x1="146.55" y1="43.7797" x2="151.193" y2="58.9588"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint7_linear_1004_147" x1="151.643" y1="63.2433" x2="158.608" y2="85.9792"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint8_linear_1004_147" x1="159.837" y1="92.1654" x2="163.621" y2="104.426"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint9_linear_1004_147" x1="222.313" y1="91.6414" x2="223.953" y2="97.0545"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint10_linear_1004_147" x1="112.91" y1="122.428" x2="114.549" y2="127.841"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint11_linear_1004_147" x1="216.599" y1="128.97" x2="218.239" y2="134.383"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint12_linear_1004_147" x1="135.363" y1="52.6913" x2="137.002" y2="58.1043"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint13_linear_1004_147" x1="193.831" y1="170.364" x2="194.833" y2="173.671"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint14_linear_1004_147" x1="170.08" y1="99.4551" x2="171.082" y2="102.762"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint15_linear_1004_147" x1="141.478" y1="147.952" x2="142.479" y2="151.259"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint16_linear_1004_147" x1="189.011" y1="51.9031" x2="189.648" y2="54.0066"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint17_linear_1004_147" x1="118.965" y1="68.63" x2="119.601" y2="70.7335"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint18_linear_1004_147" x1="144.718" y1="113.502" x2="145.355" y2="115.606"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint19_linear_1004_147" x1="195.796" y1="106.076" x2="196.432" y2="108.18"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint20_linear_1004_147" x1="204.97" y1="73.1354" x2="205.607" y2="75.2389"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint21_linear_1004_147" x1="173.974" y1="135.085" x2="174.611" y2="137.189"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint22_linear_1004_147" x1="171.933" y1="173.358" x2="172.57" y2="175.461"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint23_linear_1004_147" x1="217.536" y1="162.817" x2="218.173" y2="164.92"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint24_linear_1004_147" x1="119.405" y1="157.594" x2="120.042" y2="159.698"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint25_linear_1004_147" x1="106.713" y1="102.532" x2="107.349" y2="104.635"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint26_linear_1004_147" x1="167.565" y1="81.5992" x2="168.202" y2="83.7028"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint27_linear_1004_147" x1="156.814" y1="85.8356" x2="181.32" y2="165.478"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint28_linear_1004_147" x1="160.997" y1="98.7837" x2="178.217" y2="154.733"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#7694FF" />
            <stop offset="0.536458" stop-color="#5F82FF" />
            <stop offset="1" stop-color="#3A65FF" />
        </linearGradient>
        <linearGradient id="paint29_linear_1004_147" x1="158.597" y1="54.0751" x2="108.716" y2="98.3157"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2C315A" />
            <stop offset="0.979792" stop-color="#676B85" stop-opacity="0" />
        </linearGradient>
    </defs>
  </svg>`;
    }

    private getStar() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 150);
        return `
    <svg class="e-asset bg-asset-c ast-metior" width="102" height="76" viewBox="0 0 102 76" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
      <g opacity="0.77">
          <rect x="95.9492" y="0.0466309" width="1.15112" height="91.8086" transform="rotate(54.7081 95.9492 0.0466309)"
              fill="url(#paint0_linear_1004_41)" />
          <g filter="url(#filter0_d_1004_41)">
              <path
                  d="M25.0434 51.4617L20.46 52.5459L16.7685 49.8583L17.7011 54.3282L14.8288 58.0609L19.4122 56.9767L23.1036 59.6643L22.171 55.1944L25.0434 51.4617Z"
                  fill="white" />
          </g>
      </g>
      <defs>
          <filter id="filter0_d_1004_41" x="0.828125" y="37.8584" width="38.2148" height="37.8059"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_41" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_41" result="shape" />
          </filter>
          <linearGradient id="paint0_linear_1004_41" x1="93.8644" y1="90.4122" x2="91.8261" y2="90.3164"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00247525" stop-color="#537EFB" />
              <stop offset="0.0766" stop-color="#375CC7" />
              <stop offset="0.2176" stop-color="#354F9C" />
              <stop offset="0.3424" stop-color="#213A83" />
              <stop offset="0.4449" stop-color="#172F74" />
              <stop offset="0.518906" stop-color="#142968" />
              <stop offset="0.7697" stop-color="#191B32" stop-opacity="0.1" />
              <stop offset="1" stop-color="#0A1943" stop-opacity="0" />
          </linearGradient>
      </defs>
    </svg>
    `;
    }

    private getStarSmall() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 50);
        return `
        <svg class="e-asset bg-asset-c h-s-1-2 ast-metior" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
            <rect width="0.46522" height="37.1039" transform="matrix(-0.678332 -0.734756 -0.734756 0.678332 44.1143 0.826904)" fill="url(#paint0_linear_1628_2)"/>
            <g filter="url(#filter0_d_1628_2)">
            <path d="M17.8333 24.539L17.0198 26.2599L17.7722 27.9449L16.0835 27.2008L14.3667 28.0228L15.1802 26.3019L14.4278 24.6169L16.1165 25.361L17.8333 24.539Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_d_1628_2" x="0.366211" y="12.5391" width="31.4668" height="31.4836" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="2"/>
            <feGaussianBlur stdDeviation="7"/>
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1628_2"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1628_2" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_1628_2" x1="-0.842579" y1="36.5207" x2="-1.66631" y2="36.482" gradientUnits="userSpaceOnUse">
            <stop offset="0.00247525" stop-color="#537EFB"/>
            <stop offset="0.0766" stop-color="#375CC7"/>
            <stop offset="0.2176" stop-color="#354F9C"/>
            <stop offset="0.3424" stop-color="#213A83"/>
            <stop offset="0.4449" stop-color="#172F74"/>
            <stop offset="0.518906" stop-color="#142968"/>
            <stop offset="0.7697" stop-color="#191B32" stop-opacity="0.1"/>
            <stop offset="1" stop-color="#0A1943" stop-opacity="0"/>
            </linearGradient>
            </defs>
        </svg>
        `;
    }

    private multistars() {
        let top = this.randomIntFromInterval(10, $("#render-div").height());
        let left = this.randomIntFromInterval(10, $("#render-div").width() - 150);
        return `
    <svg class="e-asset bg-asset-c h-s-1-5" width="73" height="56" viewBox="0 0 73 56" fill="none" xmlns="http://www.w3.org/2000/svg" style="position:absolute;top:`+ top + `px;left:` + left + `px;">
      <g filter="url(#filter0_d_1004_461)">
          <path
              d="M14.9906 28.7106L16.5587 29.0018L17.763 28.0319L17.5212 29.5591L18.5542 30.7743L16.9861 30.4832L15.7818 31.453L16.0236 29.9258L14.9906 28.7106Z"
              fill="white" />
      </g>
      <g filter="url(#filter1_d_1004_461)">
          <path
              d="M54.231 26.7563L55.142 28.0654L56.6804 28.2217L55.4351 29.1383L55.3161 30.7288L54.4051 29.4197L52.8668 29.2634L54.112 28.3467L54.231 26.7563Z"
              fill="white" />
      </g>
      <g filter="url(#filter2_d_1004_461)">
          <path
              d="M43.7539 16.2895L45.0697 18.1802L47.2914 18.406L45.493 19.7298L45.3211 22.0269L44.0053 20.1362L41.7836 19.9104L43.5821 18.5866L43.7539 16.2895Z"
              fill="white" />
      </g>
      <g filter="url(#filter3_d_1004_461)">
          <path
              d="M29.7199 12.4699L30.5416 13.6507L31.9292 13.7917L30.806 14.6185L30.6986 16.053L29.8769 14.8723L28.4894 14.7313L29.6126 13.9045L29.7199 12.4699Z"
              fill="white" />
      </g>
      <g filter="url(#filter4_d_1004_461)">
          <path
              d="M26.0022 23.2738L26.4811 23.9619L27.2896 24.0441L26.6351 24.5259L26.5726 25.3618L26.0937 24.6737L25.2852 24.5916L25.9397 24.1098L26.0022 23.2738Z"
              fill="white" />
      </g>
      <g filter="url(#filter5_d_1004_461)">
          <path
              d="M57.0022 37.2738L57.4811 37.9619L58.2896 38.0441L57.6351 38.5259L57.5726 39.3618L57.0937 38.6737L56.2852 38.5916L56.9397 38.1098L57.0022 37.2738Z"
              fill="white" />
      </g>
      <defs>
          <filter id="filter0_d_1004_461" x="0.990234" y="16.032" width="31.5645" height="31.4209"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_461" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_461" result="shape" />
          </filter>
          <filter id="filter1_d_1004_461" x="38.8672" y="14.7563" width="31.8125" height="31.9724"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_461" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_461" result="shape" />
          </filter>
          <filter id="filter2_d_1004_461" x="27.7832" y="4.28955" width="33.5078" height="33.7373"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_461" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_461" result="shape" />
          </filter>
          <filter id="filter3_d_1004_461" x="14.4902" y="0.469971" width="31.4395" height="31.583"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_461" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_461" result="shape" />
          </filter>
          <filter id="filter4_d_1004_461" x="11.2852" y="11.2739" width="30.0039" height="30.0879"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_461" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_461" result="shape" />
          </filter>
          <filter id="filter5_d_1004_461" x="42.2852" y="25.2739" width="30.0039" height="30.0879"
              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="7" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.74 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1004_461" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1004_461" result="shape" />
          </filter>
      </defs>
    </svg>
    `;
    }
}
